import { render } from "./index.vue?vue&type=template&id=348aff26&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=348aff26&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-348aff26"

export default script